import React from 'react';
import {
  Box,
  Button,
  Typography,
} from '@mui/material';

const BulkUploadPanelSubmitErrorSection = ({
  submitError,
  duplicateFileError,
  isSubmitting,
  isValidating,
  onSubmitDuplicate,
}) => {
  if (!submitError) {
    return null;
  }

  return (
    <Box sx={{ marginTop: '1rem' }}>
      {duplicateFileError ? (
        <Box
          sx={{
            border: '1px solid #F5D9B5',
            borderRadius: '8px',
            backgroundColor: '#FFF8EE',
            padding: '0.75rem 1rem',
          }}
        >
          <Typography sx={{ fontSize: '0.95rem', fontWeight: 700, color: '#A85700', marginBottom: '0.25rem' }}>
            Possible duplicate upload
          </Typography>
          <Typography sx={{ fontSize: '0.875rem', color: '#515151', marginBottom: '0.5rem' }}>
            This file appears to match an existing upload.
          </Typography>
          <Typography sx={{ fontSize: '0.8125rem', color: '#515151', marginBottom: '0.75rem' }}>
            Review the previous upload or continue anyway.
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
            <Box
              component="a"
              href={duplicateFileError.url}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: 'primary.main',
                textDecoration: 'underline',
                fontSize: '0.875rem',
                fontWeight: 500,
                whiteSpace: 'nowrap',
              }}
            >
              Open existing upload
            </Box>
            <Button
              variant="text"
              size="small"
              disabled={isSubmitting || isValidating}
              onClick={onSubmitDuplicate}
              sx={{
                textTransform: 'none',
                fontWeight: 600,
                minWidth: 0,
                padding: 0,
                color: 'primary.main',
              }}
            >
              Submit anyway
            </Button>
          </Box>
        </Box>
      ) : (
        <>
          <Typography sx={{ fontSize: '1rem', fontWeight: 700, color: 'error.main', marginBottom: '0.25rem' }}>
            Unable to submit this upload.
          </Typography>
          <Typography sx={{ fontWeight: 500, color: 'error.main' }}>
            {submitError}
          </Typography>
        </>
      )}
    </Box>
  );
};

export default BulkUploadPanelSubmitErrorSection;
